import { render } from "./setup-two-factor.vue?vue&type=template&id=5ab3b690&scoped=true"
import script from "./setup-two-factor.vue?vue&type=script&lang=js"
export * from "./setup-two-factor.vue?vue&type=script&lang=js"

import "./setup-two-factor.vue?vue&type=style&index=0&id=5ab3b690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab3b690"]])

export default __exports__